import styled from 'styled-components'
import { orange, textMuted, white, surface2, border1 } from '@/theme/colors'
import { shadows, radii, motion, layers } from '@/theme/tokens'
import { fontSizes } from '@/theme/typography'
import { Input, FieldLabel } from '@components/Field'

export const CurrencySelectContainer = styled.div`
	margin-bottom: 20px;

	&:last-child {
		margin-bottom: 0;
	}
`

export const CurrencySelectWrapper = styled.div`
	position: relative;
	width: 100%;
`

export const CurrencyInput = styled(Input)`
	padding-right: 48px;
	cursor: pointer;

	&[readonly] {
		cursor: pointer;
	}
`

export const SearchIcon = styled.span`
	position: absolute;
	right: 16px;
	top: 50%;
	transform: translateY(-50%);
	pointer-events: none;
	color: ${textMuted};
	display: flex;
	align-items: center;
	justify-content: center;
`

export const CurrencyLabel = styled(FieldLabel)`
	display: block;
	margin-bottom: 8px;
`

/** Portal-positioned popover list on the overlay shadow. */
export const CurrencyDropdown = styled.div<{ $top: number; $left: number; $width: number }>`
	position: fixed;
	top: ${({ $top }) => $top}px;
	left: ${({ $left }) => $left}px;
	width: ${({ $width }) => $width}px;
	background: ${white};
	border: 1px solid ${border1};
	border-radius: ${radii.inner};
	box-shadow: ${shadows.overlay};
	max-height: 300px;
	overflow-y: auto;
	z-index: ${layers.popover};
`

export const CurrencyDropdownItem = styled.div<{ $isSelected: boolean }>`
	padding: 12px 16px;
	cursor: pointer;
	display: flex;
	flex-direction: column;
	gap: 4px;
	transition: background-color ${motion.fast};
	background-color: ${({ $isSelected }) => ($isSelected ? `${orange}14` : 'white')};

	&:hover {
		background-color: ${({ $isSelected }) => ($isSelected ? `${orange}26` : surface2)};
	}

	&:first-child {
		border-top-left-radius: 8px;
		border-top-right-radius: 8px;
	}

	&:last-child {
		border-bottom-left-radius: 8px;
		border-bottom-right-radius: 8px;
	}
`

export const CurrencyCode = styled.span`
	font-weight: 500;
`

export const CurrencyName = styled.span`
	color: ${textMuted};
	font-size: ${fontSizes.small};
`

export const EmptyCurrencyDropdownItem = styled(CurrencyDropdownItem)`
	cursor: default;
`
